// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fms-header {
  position: fixed;
  top: 10px;
  left: 20px;
  right: 0;
  z-index: 9;
  border-radius: 8px;
}

.profile-link {
  height: auto;
  text-align: center;
  padding: 7px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  margin: auto;
  position: relative;
}
.profile-link a {
  color: inherit;
}

.logo {
  max-height: 49px;
  max-width: 100%;
  height: auto;
  display: block;
  padding: 8px;
}

.logo-section {
  padding: 0 10px;
  max-width: 320px;
  display: flex;
  align-items: center;
  margin-right: auto;
  border-radius: 8px;
}
.logo-section a {
  display: block;
}

.collapse-header {
  background: none;
  border: 0;
  float: left;
  padding: 9px 12px;
  border-radius: 0 0 26px 0;
  cursor: pointer;
  outline: 0;
}

.navbar-menu {
  list-style: none;
  padding: 0;
}

.nav-link-text {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: "#3A3A39";
}

.header-open .nav-link-text {
  display: inline-block;
}
.header-open .left-nav {
  width: 200px;
}
.header-open .navbar-menu-item {
  text-align: left;
}

.left-nav {
  position: absolute;
  left: 20px;
  top: 50px;
  bottom: 0;
  z-index: 1;
  width: 100px;
}
.left-nav .nav {
  height: calc(100vh - 44px - 50px);
}
.left-nav {
  /* @media (max-width: 1270px) {
    //max-width: 685px;
    max-width: calc(100vw - 0px - 255px - 150px);
    .sidebar-collapse & {
      max-width: calc(100vw - 0px - 255px - 150px);
    }
  } */
}
@media (max-width: 959px) {
  .left-nav {
    max-width: none;
  }
  .sidebar-collapse .left-nav {
    max-width: none;
  }
}

.right-nav {
  float: right;
  background: #fff;
  color: #045266;
  border-radius: 0 0 0 40px;
  padding-left: 15px;
}
.right-nav .user-avatar {
  display: inline-block;
  padding: 5px;
  border-radius: 50px;
  color: #fff;
  margin-right: 10px;
}
.right-nav .counter {
  left: auto;
  right: 8px;
  min-width: inherit;
  top: 8px;
  width: 12px;
  height: 12px;
}
.right-nav .nav > li > a {
  height: 44px;
  display: flex;
  align-items: center;
}
.right-nav .user-menu-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.right-nav .has-menu {
  width: 150px;
}
.right-nav .has-menu > a span,
.right-nav .has-menu > a svg {
  vertical-align: middle;
}

.nav-container {
  font-size: 12px;
  display: flex;
  align-items: center;
}
.nav-container .notification-link svg {
  margin-top: 4px;
}

.header-link {
  align-items: center;
  position: relative;
  margin-left: 10px;
  padding-left: 10px;
}
.header-link a {
  display: block;
  padding: 0;
}
.header-link:before {
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -15px;
  height: 30px;
  width: 1px;
  content: "";
}
.header-link ~ .header-link:before {
  background: rgba(0, 0, 0, 0.15);
}
.header-link:last-child {
  margin-right: 10px;
}

.nav {
  list-style: none;
  margin: 0;
  padding: 0;
}
.nav > li {
  float: left;
}
.nav > li > button {
  padding: 6px 20px 8px;
  color: inherit;
}
.nav > li > a {
  padding: 6px 20px 8px;
  font-weight: 400;
  font-size: 13px;
  color: inherit;
}
.nav a {
  display: block;
  padding: 9px;
  color: #fff;
  text-decoration: none;
  line-height: 16px;
}
.nav svg {
  vertical-align: top;
}
.nav span {
  vertical-align: top;
}

.left-nav .nav svg,
.left-nav .nav span {
  vertical-align: middle;
}

.right-nav svg {
  margin-right: 0;
}
.right-nav .nav > li > a {
  padding-left: 10px;
  padding-right: 10px;
}

.navbar-menu {
  padding-top: 4px;
  margin-top: 30px;
}
.navbar-menu .navbar-menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 65px;
  width: 80px;
  background: #FFFFFF;
  margin-top: 5px;
  border-left: 3px solid #FFFFFF;
  box-shadow: 0px 8px 16px rgba(12, 26, 75, 0.04), 0px 6px 16px -1px rgba(50, 50, 71, 0.05);
  border-radius: 8px;
  color: inherit;
  z-index: 6;
}

.nav .ScrollbarsCustom-Track {
  display: none;
}

.apps-menu .scrollable-area {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: 340px;
  overflow: auto;
}

.apps-menu .default-view {
  text-align: center;
}
.apps-menu .default-view li {
  display: inline-block;
  width: 30%;
  text-align: center;
  vertical-align: top;
  padding: 0;
}
.apps-menu .default-view a {
  box-sizing: border-box;
  border: 1px solid transparent;
  display: block;
  height: 93px;
  padding: 0;
  padding-top: 20px;
}
.apps-menu .default-view a:hover {
  color: #00c179;
  background: none;
  border-color: #B2B5C4;
}
.apps-menu .default-view .apps-menu-icon {
  display: block;
  margin: 0 auto 10px;
  min-width: 32px;
  min-height: 32px;
}

.apps-search-form {
  position: relative;
  padding: 10px 15px 10px 45px;
}
.apps-search-form .toggle-apps-view {
  position: absolute;
  top: 0;
  left: 0;
  color: #666;
  padding: 12px 15px;
}
.apps-search-form .toggle-apps-view svg {
  color: currentColor;
}
.apps-search-form .searchAppsTextField {
  width: 100%;
  outline: 0;
  padding: 2px 7px 2px 20px;
  box-sizing: border-box;
}
.apps-search-form .appsSearchFrom {
  position: relative;
}
.apps-search-form .appsSearchFrom svg {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px;
  min-width: inherit;
  min-height: inherit;
  color: #B2B5C4;
}

.viewAllApps {
  background: #B2B5C4;
  padding: 6px 12px;
  margin-top: 36px;
}

.logout-trigger,
.menuIcon {
  display: none !important;
  padding: 5px;
  color: #fff;
  cursor: pointer;
}

.nav-collapse {
  transition: all 5s ease;
}

.logo-section .collapse-sidebar-trigger {
  font-size: 30px;
  margin: 0 10px 0 15px;
}

@media (max-width: 1499px) {
  .right-nav .nav > li > a {
    padding-right: 10px;
    padding-left: 10px;
  }
  /* .nav > li > a {
  	//padding: 12px 10px 19px
  } */
}
@media (max-width: 959px) {
  .nav > li > a {
    padding: 8px 15px;
  }
  /* .logo-section,
  .right-nav,
  .left-nav {
    float: none;
  } */
  .nav-collapse.collapse {
    height: 0;
    overflow: hidden;
  }
  /* .nav > li {
    float: none;
  } */
  .logout-trigger,
  .menuIcon {
    display: block !important;
  }
  .header-open .left-nav {
    left: 0;
  }
  .navbar-menu .navbar-menu-item {
    display: block;
  }
  .nav-link-text {
    display: inline-block;
  }
}
.profile-menu .MuiSvgIcon-root, .profile-menu .MuiIcon-root {
  margin-right: 10px;
  opacity: 0.3;
}

.fms-header .demo-notification-bar {
  position: absolute;
  right: 186px;
  top: 0;
  margin: 7px 0;
}
.fms-header .demo-notification-bar a {
  color: inherit;
  text-decoration: underline;
}

@media (max-width: 599px) {
  .right-nav .has-menu {
    width: auto;
  }
  .right-nav .user-avatar {
    margin-right: 0;
  }
  .user-menu-name {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AAAF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,kBAAA;AACF;AAAE;EACE,cAAA;AAEJ;;AACA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAEF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAGF;AAFE;EACE,cAAA;AAIJ;;AADA;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;AAIF;;AAFA;EACE,gBAAA;EACA,UAAA;AAKF;;AAHA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAMF;;AAFE;EACE,qBAAA;AAKJ;AAHE;EACE,YC1CqB;AD+CzB;AAHE;EACE,gBAAA;AAKJ;;AAFA;EACE,kBAAA;EACA,UAAA;EACA,SClDa;EDmDb,SAAA;EAEA,UAAA;EAEA,YAAA;AAGF;AADE;EACE,iCAAA;AAGJ;AAdA;EAcE;;;;;;KAAA;AASF;AAFE;EArBF;IAsBI,eAAA;EAKF;EAJE;IACE,eAAA;EAMJ;AACF;;AAHA;EACE,YAAA;EACA,gBAAA;EACA,cCxDO;EDyDP,yBAAA;EACA,kBAAA;AAMF;AALE;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,WCrEQ;EDsER,kBAAA;AAOJ;AALE;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAOJ;AALE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAOJ;AAJE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAMJ;AAJE;EACE,YAAA;AAMJ;AAJM;;EAEE,sBAAA;AAMR;;AADA;EAEE,eAAA;EACA,aAAA;EACA,mBAAA;AAGF;AADI;EACE,eAAA;AAGN;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAEF;AADE;EACE,cAAA;EACA,UAAA;AAGJ;AADE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAGJ;AADE;EACE,+BAAA;AAGJ;AADE;EACE,kBAAA;AAGJ;;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAEF;AADE;EACE,WAAA;AAGJ;AAFI;EAEE,qBAAA;EACA,cAAA;AAGN;AADI;EAEE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEN;AACE;EACE,cAAA;EACA,YAAA;EACA,WClKQ;EDmKR,qBAAA;EACA,iBAAA;AACJ;AACE;EACE,mBAAA;AACJ;AACE;EACE,mBAAA;AACJ;;AAKI;;EAEE,sBAAA;AAFN;;AAQE;EACE,eAAA;AALJ;AAQE;EACE,kBAAA;EACA,mBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,gBAAA;AAPF;AAQE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,yFAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AANJ;;AAiBE;EACE,aAAA;AAdJ;;AAiBA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;AAdF;;AAgBA;EACE,kBAAA;AAbF;AAcE;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAZJ;AAcE;EACE,sBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AAZJ;AAaI;EACE,cC7RO;ED8RP,gBAAA;EACA,qBC5PQ;ADiPd;AAcE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,4BAAA;AAbF;AAcE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WClQO;EDmQP,kBAAA;AAZJ;AAaI;EACE,mBAAA;AAXN;AAcE;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;AAZJ;AAcE;EACE,kBAAA;AAZJ;AAaI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cCnSQ;ADwRd;;AAgBA;EACE,mBCzSY;ED0SZ,iBAAA;EACA,gBAAA;AAbF;;AAeA;;EAEE,wBAAA;EACA,YAAA;EACA,WChTU;EDiTV,eAAA;AAZF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,eAAA;EACA,qBAAA;AAXF;;AAeA;EACE;IACE,mBAAA;IACA,kBAAA;EAZF;EAcA;;KAAA;AAVF;AAmBA;EACE;IACE,iBAAA;EAjBF;EAmBA;;;;KAAA;EAKA;IACE,SAAA;IACA,gBAAA;EAjBF;EAmBA;;KAAA;EAGA;;IAEE,yBAAA;EAjBF;EAqBE;IACE,OAAA;EAnBJ;EAsBA;IACE,cAAA;EApBF;EAsBA;IACE,qBAAA;EApBF;AACF;AAwBE;EACE,kBAAA;EACA,YAAA;AAtBJ;;AA0BA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;AAvBF;AAyBE;EACE,cAAA;EACA,0BAAA;AAvBJ;;AA2BA;EACE;IACE,WAAA;EAxBF;EA0BA;IACE,eAAA;EAxBF;EA0BA;IACE,aAAA;EAxBF;AACF","sourcesContent":["@import './../../assets/variables';\n.fms-header {\n  position: fixed;\n  top: 10px;\n  left: 20px;\n  right: 0;\n  z-index: 9;\n  border-radius: 8px;\n}\n.profile-link {\n  height: auto;\n  text-align: center;\n  padding: 7px;\n  box-shadow: 0 0 3px rgba(#000, 0.2);\n  margin: auto;\n  position: relative;\n  a {\n    color: inherit;\n  }\n}\n.logo {\n  max-height: 49px;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  padding: 8px;\n}\n.logo-section {\n  padding: 0 10px;\n  max-width: 320px;\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n  border-radius: 8px;\n  a {\n    display: block;\n  }\n}\n.collapse-header {\n  background: none;\n  border: 0;\n  float: left;\n  padding: 9px 12px;\n  border-radius: 0 0 26px 0;\n  cursor: pointer;\n  outline: 0;\n}\n.navbar-menu {\n  list-style: none;\n  padding: 0;\n}\n.nav-link-text {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color:\"#3A3A39\"\n}\n\n.header-open {\n  .nav-link-text {\n    display: inline-block;\n  }\n  .left-nav {\n    width: $headerNavWidthExpended;\n  }\n  .navbar-menu-item {\n    text-align: left;\n  }\n}\n.left-nav {\n  position: absolute;\n  left: 20px;\n  top: $headerHeight;\n  bottom: 0;\n  // box-shadow: 0 0 3px 1px rgba(#000000, 0.15);\n  z-index: 1;\n  // width: $headerNavWidth;\n  width: 100px;\n  // overflow: hidden;\n  .nav {\n    height: calc(100vh - 44px - 50px);\n  }\n\n  /* @media (max-width: 1270px) {\n    //max-width: 685px;\n    max-width: calc(100vw - 0px - 255px - 150px);\n    .sidebar-collapse & {\n      max-width: calc(100vw - 0px - 255px - 150px);\n    }\n  } */\n  @media (max-width: 959px) {\n    max-width: none;\n    .sidebar-collapse & {\n      max-width: none;\n    }\n  }\n}\n.right-nav {\n  float: right;\n  background: #fff;\n  color: $menuBg;\n  border-radius: 0 0 0 40px;\n  padding-left: 15px;\n  .user-avatar {\n    display: inline-block;\n    padding: 5px;\n    border-radius: 50px;\n    color: $linkColor;\n    margin-right: 10px;\n  }\n  .counter {\n    left: auto;\n    right: 8px;\n    min-width: inherit;\n    top: 8px;\n    width: 12px;\n    height: 12px;\n  }\n  .nav > li > a {\n    height: 44px;\n    display: flex;\n    align-items: center;\n  }\n\n  .user-menu-name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: 0;\n  }\n  .has-menu {\n    width: 150px;\n    > a {\n      span,\n      svg {\n        vertical-align: middle;\n      }\n    }\n  }\n}\n.nav-container {\n  //border-bottom: 1px solid darken($menuBg, 1.5%);\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  .notification-link {\n    svg {\n      margin-top: 4px;\n    }\n  }\n}\n.header-link {\n  align-items: center;\n  position: relative;\n  margin-left: 10px;\n  padding-left: 10px;\n  a {\n    display: block;\n    padding: 0;\n  }\n  &:before {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    margin-top: -15px;\n    height: 30px;\n    width: 1px;\n    content: \"\";\n  }\n  & ~ &:before {\n    background: rgba(#000, 0.15);\n  }\n  &:last-child {\n    margin-right: 10px;\n  }\n}\n\n.nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  > li {\n    float: left;\n    > button {\n      //border-left: 1px solid darken($menuBg, 1.5%);\n      padding: 6px 20px 8px;\n      color: inherit;\n    }\n    > a {\n      //border-left: 1px solid darken($menuBg, 1.5%);\n      padding: 6px 20px 8px;\n      font-weight: 400;\n      font-size: 13px;\n      color: inherit;\n    }\n  }\n  a {\n    display: block;\n    padding: 9px;\n    color: $linkColor;\n    text-decoration: none;\n    line-height: 16px;\n  }\n  svg {\n    vertical-align: top;\n  }\n  span {\n    vertical-align: top;\n  }\n}\n\n.left-nav {\n  .nav {\n    svg,\n    span {\n      vertical-align: middle;\n    }\n     \n  }\n}\n.right-nav {\n  svg {\n    margin-right: 0;\n  }\n\n  .nav > li > a {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n\n.navbar-menu {\n  padding-top: 4px;\n  margin-top: 30px;\n  .navbar-menu-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 65px;\n    width: 80px;\n    background: #FFFFFF;\n    margin-top: 5px;\n    border-left: 3px solid #FFFFFF;\n    box-shadow: 0px 8px 16px rgba(12, 26, 75, 0.04), 0px 6px 16px -1px rgba(50, 50, 71, 0.05);\n    border-radius: 8px;\n    color: inherit;\n    z-index: 6;\n    // display: block;\n    // padding: 7px;\n    // margin-left: 5px;\n    // text-align: center;\n    // border-radius: 30px 0 0 30px;\n    // margin-top: 4px;\n    // margin-bottom: 4px;\n  }\n}\n.nav {\n  .ScrollbarsCustom-Track {\n    display: none;\n  }\n}\n.apps-menu .scrollable-area {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  height: 340px;\n  overflow: auto;\n}\n.apps-menu .default-view {\n  text-align: center;\n  li {\n    display: inline-block;\n    width: 30%;\n    text-align: center;\n    vertical-align: top;\n    padding: 0;\n  }\n  a {\n    box-sizing: border-box;\n    border: 1px solid transparent;\n    display: block;\n    height: 93px;\n    padding: 0;\n    padding-top: 20px;\n    &:hover {\n      color: $themeColor;\n      background: none;\n      border-color: $borderColor;\n    }\n  }\n  .apps-menu-icon {\n    display: block;\n    margin: 0 auto 10px;\n    min-width: 32px;\n    min-height: 32px;\n  }\n}\n\n.apps-search-form {\n  position: relative;\n  padding: 10px 15px 10px 45px;\n  .toggle-apps-view {\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: $darkGrey;\n    padding: 12px 15px;\n    svg {\n      color: currentColor;\n    }\n  }\n  .searchAppsTextField {\n    width: 100%;\n    outline: 0;\n    padding: 2px 7px 2px 20px;\n    box-sizing: border-box;\n  }\n  .appsSearchFrom {\n    position: relative;\n    svg {\n      position: absolute;\n      left: 0;\n      top: 0;\n      padding: 5px;\n      min-width: inherit;\n      min-height: inherit;\n      color: $borderColor;\n    }\n  }\n}\n\n.viewAllApps {\n  background: $borderColor;\n  padding: 6px 12px;\n  margin-top: 36px;\n}\n.logout-trigger,\n.menuIcon {\n  display: none !important;\n  padding: 5px;\n  color: $linkColor;\n  cursor: pointer;\n}\n.nav-collapse {\n  transition: all 5s ease;\n}\n\n.logo-section .collapse-sidebar-trigger {\n  font-size: 30px;\n  margin: 0 10px 0 15px;\n}\n\n// responsive\n@media (max-width: 1499px) {\n  .right-nav .nav > li > a {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n  /* .nav > li > a {\n\t\t//padding: 12px 10px 19px\n\t} */\n  //.logo-section {\n  //margin-right: 10px;\n  //padding: 9px 0;\n  //}\n}\n\n@media (max-width: 959px) {\n  .nav > li > a {\n    padding: 8px 15px;\n  }\n  /* .logo-section,\n  .right-nav,\n  .left-nav {\n    float: none;\n  } */\n  .nav-collapse.collapse {\n    height: 0;\n    overflow: hidden;\n  }\n  /* .nav > li {\n    float: none;\n  } */\n  .logout-trigger,\n  .menuIcon {\n    display: block !important;\n  }\n\n  .header-open {\n    .left-nav {\n      left: 0;\n    }\n  }\n  .navbar-menu .navbar-menu-item {\n    display: block;\n  }\n  .nav-link-text {\n    display: inline-block;\n  }\n}\n\n.profile-menu {\n  .MuiSvgIcon-root, .MuiIcon-root {\n    margin-right: 10px;\n    opacity: 0.3;\n  }\n}\n\n.fms-header .demo-notification-bar {\n  position: absolute;\n  right: 186px;\n  top: 0;\n  margin: 7px 0;\n\n  a {\n    color: inherit;\n    text-decoration: underline;\n  }\n}\n\n@media (max-width: 599px) {\n  .right-nav .has-menu {\n    width: auto;\n  }\n  .right-nav .user-avatar {\n    margin-right: 0;\n  }\n  .user-menu-name {\n    display: none;\n  }\n}\n","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
